export enum COUNTRY_CODES {
  'af' = 'af',
  'ax' = 'ax',
  'al' = 'al',
  'dz' = 'dz',
  'as' = 'as',
  'ad' = 'ad',
  'ao' = 'ao',
  'ai' = 'ai',
  'aq' = 'aq',
  'ag' = 'ag',
  'ar' = 'ar',
  'am' = 'am',
  'aw' = 'aw',
  'au' = 'au',
  'at' = 'at',
  'az' = 'az',
  'bs' = 'bs',
  'bh' = 'bh',
  'bd' = 'bd',
  'bb' = 'bb',
  'by' = 'by',
  'be' = 'be',
  'bz' = 'bz',
  'bj' = 'bj',
  'bm' = 'bm',
  'bt' = 'bt',
  'bo' = 'bo',
  'bq' = 'bq',
  'ba' = 'ba',
  'bw' = 'bw',
  'bv' = 'bv',
  'br' = 'br',
  'io' = 'io',
  'bn' = 'bn',
  'bg' = 'bg',
  'bf' = 'bf',
  'bi' = 'bi',
  'cv' = 'cv',
  'kh' = 'kh',
  'cm' = 'cm',
  'ca' = 'ca',
  'ky' = 'ky',
  'cf' = 'cf',
  'td' = 'td',
  'cl' = 'cl',
  'cn' = 'cn',
  'cx' = 'cx',
  'cc' = 'cc',
  'co' = 'co',
  'km' = 'km',
  'cd' = 'cd',
  'cg' = 'cg',
  'ck' = 'ck',
  'cr' = 'cr',
  'ci' = 'ci',
  'hr' = 'hr',
  'cu' = 'cu',
  'cw' = 'cw',
  'cy' = 'cy',
  'cz' = 'cz',
  'dk' = 'dk',
  'dj' = 'dj',
  'dm' = 'dm',
  'do' = 'do',
  'ec' = 'ec',
  'eg' = 'eg',
  'sv' = 'sv',
  'gq' = 'gq',
  'er' = 'er',
  'ee' = 'ee',
  'eu' = 'eu',
  'sz' = 'sz',
  'et' = 'et',
  'fk' = 'fk',
  'fo' = 'fo',
  'fj' = 'fj',
  'fi' = 'fi',
  'fr' = 'fr',
  'gf' = 'gf',
  'pf' = 'pf',
  'tf' = 'tf',
  'ga' = 'ga',
  'gm' = 'gm',
  'ge' = 'ge',
  'de' = 'de',
  'gh' = 'gh',
  'gi' = 'gi',
  'gr' = 'gr',
  'gl' = 'gl',
  'gd' = 'gd',
  'gp' = 'gp',
  'gu' = 'gu',
  'gt' = 'gt',
  'gg' = 'gg',
  'gn' = 'gn',
  'gw' = 'gw',
  'gy' = 'gy',
  'ht' = 'ht',
  'hm' = 'hm',
  'va' = 'va',
  'hn' = 'hn',
  'hk' = 'hk',
  'hu' = 'hu',
  'is' = 'is',
  'in' = 'in',
  'id' = 'id',
  'ir' = 'ir',
  'iq' = 'iq',
  'ie' = 'ie',
  'im' = 'im',
  'il' = 'il',
  'it' = 'it',
  'jm' = 'jm',
  'jp' = 'jp',
  'je' = 'je',
  'jo' = 'jo',
  'kz' = 'kz',
  'ke' = 'ke',
  'ki' = 'ki',
  'kp' = 'kp',
  'kr' = 'kr',
  'kw' = 'kw',
  'kg' = 'kg',
  'la' = 'la',
  'lv' = 'lv',
  'lb' = 'lb',
  'ls' = 'ls',
  'lr' = 'lr',
  'ly' = 'ly',
  'li' = 'li',
  'lt' = 'lt',
  'lu' = 'lu',
  'mo' = 'mo',
  'mg' = 'mg',
  'mw' = 'mw',
  'my' = 'my',
  'mv' = 'mv',
  'ml' = 'ml',
  'mt' = 'mt',
  'mh' = 'mh',
  'mq' = 'mq',
  'mr' = 'mr',
  'mu' = 'mu',
  'yt' = 'yt',
  'mx' = 'mx',
  'fm' = 'fm',
  'md' = 'md',
  'mc' = 'mc',
  'mn' = 'mn',
  'me' = 'me',
  'ms' = 'ms',
  'ma' = 'ma',
  'mz' = 'mz',
  'mm' = 'mm',
  'na' = 'na',
  'nr' = 'nr',
  'np' = 'np',
  'nl' = 'nl',
  'nc' = 'nc',
  'nz' = 'nz',
  'ni' = 'ni',
  'ne' = 'ne',
  'ng' = 'ng',
  'nu' = 'nu',
  'nf' = 'nf',
  'mk' = 'mk',
  'mp' = 'mp',
  'no' = 'no',
  'om' = 'om',
  'pk' = 'pk',
  'pw' = 'pw',
  'ps' = 'ps',
  'pa' = 'pa',
  'pg' = 'pg',
  'py' = 'py',
  'pe' = 'pe',
  'ph' = 'ph',
  'pn' = 'pn',
  'pl' = 'pl',
  'pt' = 'pt',
  'pr' = 'pr',
  'qa' = 'qa',
  're' = 're',
  'ro' = 'ro',
  'ru' = 'ru',
  'rw' = 'rw',
  'bl' = 'bl',
  'sh' = 'sh',
  'kn' = 'kn',
  'lc' = 'lc',
  'mf' = 'mf',
  'pm' = 'pm',
  'vc' = 'vc',
  'ws' = 'ws',
  'sm' = 'sm',
  'st' = 'st',
  'sa' = 'sa',
  'sn' = 'sn',
  'rs' = 'rs',
  'sc' = 'sc',
  'sl' = 'sl',
  'sg' = 'sg',
  'sx' = 'sx',
  'sk' = 'sk',
  'si' = 'si',
  'sb' = 'sb',
  'so' = 'so',
  'za' = 'za',
  'gs' = 'gs',
  'ss' = 'ss',
  'es' = 'es',
  'lk' = 'lk',
  'sd' = 'sd',
  'sr' = 'sr',
  'sj' = 'sj',
  'se' = 'se',
  'ch' = 'ch',
  'sy' = 'sy',
  'tw' = 'tw',
  'tj' = 'tj',
  'tz' = 'tz',
  'th' = 'th',
  'tl' = 'tl',
  'tg' = 'tg',
  'tk' = 'tk',
  'to' = 'to',
  'tt' = 'tt',
  'tn' = 'tn',
  'tr' = 'tr',
  'tm' = 'tm',
  'tc' = 'tc',
  'tv' = 'tv',
  'ug' = 'ug',
  'ua' = 'ua',
  'ae' = 'ae',
  'gb' = 'gb',
  'um' = 'um',
  'us' = 'us',
  'uy' = 'uy',
  'uz' = 'uz',
  'vu' = 'vu',
  've' = 've',
  'vn' = 'vn',
  'vg' = 'vg',
  'vi' = 'vi',
  'wf' = 'wf',
  'eh' = 'eh',
  'ye' = 'ye',
  'zm' = 'zm',
  'zw' = 'zw',
  'zz' = 'zz', // This is a convention for handling the cases where either the country is missing from the props, or the selected country doesnt have a flag registered
}

const COUNTRY_CODES_VALUES = new Set<string>(Object.values(COUNTRY_CODES));

const isTcountryCode = (value: string): value is TcountryCode => {
  return COUNTRY_CODES_VALUES.has(value);
};

export const toCountryCode = (value: string | undefined): TcountryCode | undefined => {
  if (value == null) return undefined;
  const lower = value.toLowerCase();
  return isTcountryCode(lower) ? lower : undefined;
};

export type TcountryCode =
  | 'af'
  | 'ax'
  | 'al'
  | 'dz'
  | 'as'
  | 'ad'
  | 'ao'
  | 'ai'
  | 'aq'
  | 'ag'
  | 'ar'
  | 'am'
  | 'aw'
  | 'au'
  | 'at'
  | 'az'
  | 'bs'
  | 'bh'
  | 'bd'
  | 'bb'
  | 'by'
  | 'be'
  | 'bz'
  | 'bj'
  | 'bm'
  | 'bt'
  | 'bo'
  | 'bq'
  | 'ba'
  | 'bw'
  | 'bv'
  | 'br'
  | 'io'
  | 'bn'
  | 'bg'
  | 'bf'
  | 'bi'
  | 'cv'
  | 'kh'
  | 'cm'
  | 'ca'
  | 'ky'
  | 'cf'
  | 'td'
  | 'cl'
  | 'cn'
  | 'cx'
  | 'cc'
  | 'co'
  | 'km'
  | 'cd'
  | 'cg'
  | 'ck'
  | 'cr'
  | 'ci'
  | 'hr'
  | 'cu'
  | 'cw'
  | 'cy'
  | 'cz'
  | 'dk'
  | 'dj'
  | 'dm'
  | 'do'
  | 'ec'
  | 'eg'
  | 'sv'
  | 'gq'
  | 'er'
  | 'ee'
  | 'sz'
  | 'et'
  | 'fk'
  | 'fo'
  | 'fj'
  | 'fi'
  | 'fr'
  | 'gf'
  | 'pf'
  | 'tf'
  | 'ga'
  | 'gm'
  | 'ge'
  | 'de'
  | 'gh'
  | 'gi'
  | 'gr'
  | 'gl'
  | 'gd'
  | 'gp'
  | 'gu'
  | 'gt'
  | 'gg'
  | 'gn'
  | 'gw'
  | 'gy'
  | 'ht'
  | 'hm'
  | 'va'
  | 'hn'
  | 'hk'
  | 'hu'
  | 'is'
  | 'in'
  | 'id'
  | 'ir'
  | 'iq'
  | 'ie'
  | 'im'
  | 'il'
  | 'it'
  | 'jm'
  | 'jp'
  | 'je'
  | 'jo'
  | 'kz'
  | 'ke'
  | 'ki'
  | 'kp'
  | 'kr'
  | 'kw'
  | 'kg'
  | 'la'
  | 'lv'
  | 'lb'
  | 'ls'
  | 'lr'
  | 'ly'
  | 'li'
  | 'lt'
  | 'lu'
  | 'mo'
  | 'mg'
  | 'mw'
  | 'my'
  | 'mv'
  | 'ml'
  | 'mt'
  | 'mh'
  | 'mq'
  | 'mr'
  | 'mu'
  | 'yt'
  | 'mx'
  | 'fm'
  | 'md'
  | 'mc'
  | 'mn'
  | 'me'
  | 'ms'
  | 'ma'
  | 'mz'
  | 'mm'
  | 'na'
  | 'nr'
  | 'np'
  | 'nl'
  | 'nc'
  | 'nz'
  | 'ni'
  | 'ne'
  | 'ng'
  | 'nu'
  | 'nf'
  | 'mk'
  | 'mp'
  | 'no'
  | 'om'
  | 'pk'
  | 'pw'
  | 'ps'
  | 'pa'
  | 'pg'
  | 'py'
  | 'pe'
  | 'ph'
  | 'pn'
  | 'pl'
  | 'pt'
  | 'pr'
  | 'qa'
  | 're'
  | 'ro'
  | 'ru'
  | 'rw'
  | 'bl'
  | 'sh'
  | 'kn'
  | 'lc'
  | 'mf'
  | 'pm'
  | 'vc'
  | 'ws'
  | 'sm'
  | 'st'
  | 'sa'
  | 'sn'
  | 'rs'
  | 'sc'
  | 'sl'
  | 'sg'
  | 'sx'
  | 'sk'
  | 'si'
  | 'sb'
  | 'so'
  | 'za'
  | 'gs'
  | 'ss'
  | 'es'
  | 'lk'
  | 'sd'
  | 'sr'
  | 'sj'
  | 'se'
  | 'ch'
  | 'sy'
  | 'tw'
  | 'tj'
  | 'tz'
  | 'th'
  | 'tl'
  | 'tg'
  | 'tk'
  | 'to'
  | 'tt'
  | 'tn'
  | 'tr'
  | 'tm'
  | 'tc'
  | 'tv'
  | 'ug'
  | 'ua'
  | 'ae'
  | 'gb'
  | 'um'
  | 'us'
  | 'uy'
  | 'uz'
  | 'vu'
  | 've'
  | 'vn'
  | 'vg'
  | 'vi'
  | 'wf'
  | 'eh'
  | 'ye'
  | 'zm'
  | 'zw'
  | 'zz'; // This is a convention for handling the cases where either the country is missing from the props, or the selected country doesnt have a flag registered
